import { render, staticRenderFns } from "./AkademikDashboard.vue?vue&type=template&id=a72a48a8&scoped=true"
import script from "./AkademikDashboard.vue?vue&type=script&lang=js"
export * from "./AkademikDashboard.vue?vue&type=script&lang=js"
import style0 from "./AkademikDashboard.vue?vue&type=style&index=0&id=a72a48a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72a48a8",
  null
  
)

export default component.exports